module.exports = __webpack_public_path__ + "img/sala-eventos.b44fd03d.svg";